//angular imports
import { HttpResponse } from '@angular/common/http';

export class CacheEntry {
  response: HttpResponse<any>;
  lastRead: number;
}
